module.exports = __webpack_public_path__ + "img/ico-tableau_de_bord.eccfc3d7.svg";